import styled, { css } from "styled-components";
import COLORS from "components/atoms/colors";

interface Size {
  large: boolean;
  medium: boolean;
  small: boolean;
  xsSmall: boolean;
}

interface Style {
  size?: keyof Size;
  radiusFull?: boolean;
  width?: string;
}

const Btn = styled.button<Style>`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: "Pretendard Variable";
  font-weight: 700;
  font-size: 12px;
  width: ${({ width }) => width};

  ${({ size, radiusFull }) =>
    size &&
    {
      large: css`
        height: 44px;
        padding: 0 20px;
        border-radius: ${radiusFull ? "44px" : "4px"};
      `,
      medium: css`
        height: 40px;
        padding: 0 16px;
        border-radius: ${radiusFull ? "40px" : "4px"};
      `,
      small: css`
        height: 34px;
        padding: 0 8px;
        border-radius: ${radiusFull ? "34px" : "4px"};
      `,
      xsSmall: css`
        height: 30px;
        padding: 0 4px;
        line-height: 28px;
        border-radius: ${radiusFull ? "30px" : "4px"};
      `,
    }[size]};
`;

const buttons = {
  Blue: styled(Btn)<{ inActive?: boolean }>`
    background: ${({ inActive }) =>
      inActive ? COLORS.primary.inActive : COLORS.primary.active};
    color: "#fff";
  `,
  Red: styled(Btn)<{ inActive?: boolean }>`
    background-color: ${({ inActive }) =>
      inActive ? COLORS.error.inActive : COLORS.error.active};
  `,
  Gray: styled(Btn)`
    background: ${COLORS.primary.inActive};
    color: ${COLORS.black["40%"]};
  `,
  Line: styled(Btn)`
    border: 1px solid ${COLORS.black["60%"]};
    background-color: #fff;
    color: ${COLORS.black["60%"]};
  `,
};

export default buttons;
